import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

export default function goToSearch() {
  store.dispatch(
    pushRoute({
      route: { Page: Pages.SEARCH },
      params: { push: true },
    })
  );
}
